module.exports = __webpack_public_path__ + "static/media/1_A1_05.6655f3a7.png";